import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { orbitNodes } from '../../data/modalities';
export function ModalityOrbit() {
  const [active, setActive] = useState(0);
  const size = 560;
  const center = size / 2;
  const radius = 220;
  const positions = orbitNodes.map((_, index) => {
    const angle = index / orbitNodes.length * Math.PI * 2 - Math.PI / 2;
    return {
      x: center + radius * Math.cos(angle),
      y: center + radius * Math.sin(angle)
    };
  });
  return <div className="relative mx-auto" style={{
    width: size,
    height: size,
    maxWidth: '100%'
  }} data-id="element-94" data-mp="2733rdeao6sym">
      <svg viewBox={`0 0 ${size} ${size}`} className="absolute inset-0 h-full w-full" aria-hidden="true" data-id="element-95" data-mp="2kvjqw54d48us">
        {[0.34, 0.62, 1].map(ring => <circle key={ring} cx={center} cy={center} r={radius * ring} fill="none" stroke="#33a7b5" strokeOpacity={0.14} strokeWidth={1} data-id="element-96" data-mp="1scd1ibsn23y5" />)}
        {positions.map((position, index) => <line key={orbitNodes[index].id} x1={center} y1={center} x2={position.x} y2={position.y} stroke="#33a7b5" strokeOpacity={index === active ? 0.58 : 0.16} strokeWidth={index === active ? 1.5 : 1} data-id="element-97" data-mp="10ve4gaqhxhnl" data-mpi={index} />)}
      </svg>

      <div className="absolute left-1/2 top-1/2 flex h-[164px] w-[164px] -translate-x-1/2 -translate-y-1/2 flex-col items-center justify-center rounded-full bg-navy px-6 text-center shadow-2xl shadow-navy/30" data-id="element-98" data-mp="d14ekhkeszep">
        <p className="text-[9px] font-semibold uppercase tracking-[0.18em] text-teal-light" data-id="element-99" data-mp="rw0tfdmq4l0r">
          JAG Medical Solutions
        </p>
        <motion.p key={active} initial={{
        opacity: 0,
        y: 4
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.2
      }} className="mt-2 font-display text-[14px] font-bold leading-tight text-white" data-id="element-100" data-mp="1yb1g0spuzquo">
          {orbitNodes[active].name}
        </motion.p>
        <motion.p key={`detail-${active}`} initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.25
      }} className="mt-2 text-[10px] leading-snug text-white/65" data-id="element-101" data-mp="c8bczuk00tmg">
          {orbitNodes[active].detail}
        </motion.p>
      </div>

      {positions.map((position, index) => {
      const node = orbitNodes[index];
      const isActive = index === active;
      return <motion.button key={node.id} type="button" onMouseEnter={() => setActive(index)} onFocus={() => setActive(index)} onClick={() => setActive(index)} initial={false} animate={{
        scale: isActive ? 1.1 : 1
      }} transition={{
        type: 'spring',
        stiffness: 300,
        damping: 22
      }} className={`absolute flex h-[80px] w-[80px] flex-col items-center justify-center rounded-full text-center outline-none transition-colors focus-visible:ring-2 focus-visible:ring-teal focus-visible:ring-offset-2 ${isActive ? 'z-10 bg-teal text-white shadow-lg shadow-teal/40' : 'bg-white text-navy shadow-md shadow-navy/10 hover:bg-slate-50'}`} style={{
        left: position.x,
        top: position.y,
        transform: 'translate(-50%, -50%)'
      }} aria-label={node.name} aria-pressed={isActive} data-id="element-102" data-mp="3ko4uocq2gb53" data-mpi={index}>
            <span className="px-1.5 text-[9px] font-semibold leading-tight" data-id="element-103" data-mp="1g7q41cympq3a">
              {node.name}
            </span>
            {node.status && <span className={`mt-1 text-[7px] font-semibold uppercase tracking-wide ${isActive ? 'text-white/75' : 'text-teal'}`} data-id="element-104" data-mp="1l7umv9n0ewwo">
                Soon
              </span>}
          </motion.button>;
    })}
    </div>;
}